import React from 'react'
import styles from './styles.module.scss'
import Tile from '../Tile'
import AnchorLink from '../AnchorLink'

function WorkplaceTile({
  workplaceId,
  workplaceName,
  color,
  initials,
  onClick,
  size = 'xSmall',
  className,
  tileClassName,
  isNative
}) {
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }
  return (
    <AnchorLink
      isNative={isNative}
      handleClick={handleClick}
      backNavigation={true}
      path={`/0/workplace/settings/${workplaceId}`}
      className={`${styles.tileWrapper} ${className}`}>
      <Tile size={size} color={color} className={tileClassName}>
        {initials}
      </Tile>
      <p className={`${styles.workplaceName} ${styles[size]}`}>{workplaceName}</p>
    </AnchorLink>
  )
}

export default WorkplaceTile
